console.log('🔥🔥🔥🔥 awtomic-filter.js loaded 🔥🔥🔥🔥');

// Detect OS and add class to body
(() => {
    const platform = navigator.platform.toLowerCase();
    const userAgent = navigator.userAgent.toLowerCase();
    const isWindows = platform.includes('win') || userAgent.includes('windows');
    const isMac = platform.includes('mac') || userAgent.includes('macintosh');

    if (isWindows) {
        document.body.classList.add('os-windows');
    } else if (isMac) {
        document.body.classList.add('os-mac');
    }
})();

(() => {
    // utils/common.js
    function poll(t, i, o = false, e = 1e4, a = 25) {
        e < 0 || (t() ? i() : setTimeout(() => {
            poll(t, i, o, o ? e : e - a, a);
        }, a));
    }
    function q(s, o) {
        return o ? s.querySelector(o) : document.querySelector(s);
    }
    function qq(s, o) {
        return o ? s.querySelectorAll(o) : document.querySelectorAll(s);
    }
    function insert(target, position, element, exists) {
        if (!exists) {
            typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
        }
    }


    // src/once_upon_a_farm/susbcription_filter/v1/info.js
    var ID = "susbcription_filter";
    var VAR = "v1";

    // src/once_upon_a_farm/susbcription_filter/v1/index.js
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
        name: "",
        variation: `${VAR}`,
        logs: []
    };
    var styleTag = document.createElement("style");
    styleTag.textContent = `
    .category-group.mobile > div {
      transition: max-height 0.3s ease-out, opacity 0.2s ease-out;
      overflow: hidden;
    }
    
    .category-group.mobile > div.hidden {
      max-height: 0;
      opacity: 0;
    }
    
    .category-group.mobile > div:not(.hidden) {
      max-height: 500px;
      opacity: 1;
    }
    
    .chakra-button__icon {
      transition: transform 0.3s ease;
    }
    
    .chakra-button__icon.rotate-180 {
      transform: rotate(180deg);
    }
  `;
    document.head.appendChild(styleTag);
    var filterSidebar = (categoryList) => {
        const sidebarHTML = `
      <div class="filter-sidebar hidden">
        <div class='filter-header'>
          <h2>Filter <span class='filter-count'></span></h2>
          <div class='filter-header-buttons'>
            <span class='sidebar-product-count'></span>
            <span class='close-button'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_464_799)">
                <path d="M15.6451 0.367084C15.1718 -0.106181 14.4073 -0.106181 13.934 0.367084L8 6.28897L2.06598 0.354949C1.59272 -0.118316 0.828214 -0.118316 0.354949 0.354949C-0.118316 0.828214 -0.118316 1.59272 0.354949 2.06598L6.28897 8L0.354949 13.934C-0.118316 14.4073 -0.118316 15.1718 0.354949 15.6451C0.828214 16.1183 1.59272 16.1183 2.06598 15.6451L8 9.71104L13.934 15.6451C14.4073 16.1183 15.1718 16.1183 15.6451 15.6451C16.1183 15.1718 16.1183 14.4073 15.6451 13.934L9.71104 8L15.6451 2.06598C16.1062 1.60485 16.1062 0.828214 15.6451 0.367084Z" fill="black"/>
                </g>
                <defs>
                <clipPath id="clip0_464_799">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </span>
          </div>
        </div>
  
        <div class="filter-content">
          ${[...categoryList].map((category) => {
            const subcategory = category.nextElementSibling;
            return `
            <div class="category-group">
              ${category.outerHTML}
              ${subcategory ? subcategory.outerHTML : ""} 
            </div>
          `;
        }).join("")}
        </div>
  
        <div class="filter-footer">
          <button class="apply-button">DONE</button>
          <button class="clear-button">Clear All</button>
        </div>
      </div>
    `;
        return sidebarHTML;
    };
    var filterSidebarMobile = (categoryList) => {
        const filterContent = [...categoryList].map((category) => {
            const categoryText = category.textContent.trim();
            const expandIcon = `<svg viewBox="0 0 24 24" focusable="false" class="chakra-icon css-onkibi" aria-hidden="true">
                    <path fill="currentColor" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                </svg>`;
            return `
                <div class="category-group mobile">
                <button type="button" class="chakra-button awt-filter-button css-14c9rq">
                    ${categoryText}
                    <span class="chakra-button__icon css-1hzyiq5">${expandIcon}</span>
                </button>
                </div>
            `;
        }).join("");
        return `
      <div class="filter-sidebar mobile hidden">
        <div class='filter-header'>
          <h2>Filter <span class='filter-count'></span></h2>
          <div class='filter-header-buttons'>
            <span class='sidebar-product-count'></span>
            <span class='close-button'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_464_799)">
                  <path d="M15.6451 0.367084C15.1718 -0.106181 14.4073 -0.106181 13.934 0.367084L8 6.28897L2.06598 0.354949C1.59272 -0.118316 0.828214 -0.118316 0.354949 0.354949C-0.118316 0.828214 -0.118316 1.59272 0.354949 2.06598L6.28897 8L0.354949 13.934C-0.118316 14.4073 -0.118316 15.1718 0.354949 15.6451C0.828214 16.1183 1.59272 16.1183 2.06598 15.6451L8 9.71104L13.934 15.6451C14.4073 16.1183 15.1718 16.1183 15.6451 15.6451C16.1183 15.1718 16.1183 14.4073 15.6451 13.934L9.71104 8L15.6451 2.06598C16.1062 1.60485 16.1062 0.828214 15.6451 0.367084Z" fill="black"/>
                </g>
              </span>
            </div>
          </div>
        <div class="filter-content">
          ${filterContent}
        </div>
        <div class="filter-footer">
          <button class="apply-button">DONE</button>
          <button class="clear-button">Clear All</button>
        </div>
      </div>
    `;
    };
    var filterButton = `<div class="filter-button-container">
      <div class="button-count">
      <div class="filter-button-cheap-container-inner">
        <button id="filter-button" class='sc-lnsxGb ggMOlf css-qdde6k'>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.7084 9.99999H7.41258M3.77841 9.99999H2.29175M3.77841 9.99999C3.77841 9.51818 3.96981 9.0561 4.3105 8.71541C4.6512 8.37472 5.11327 8.18332 5.59508 8.18332C6.07689 8.18332 6.53897 8.37472 6.87966 8.71541C7.22035 9.0561 7.41175 9.51818 7.41175 9.99999C7.41175 10.4818 7.22035 10.9439 6.87966 11.2846C6.53897 11.6253 6.07689 11.8167 5.59508 11.8167C5.11327 11.8167 4.6512 11.6253 4.3105 11.2846C3.96981 10.9439 3.77841 10.4818 3.77841 9.99999ZM17.7084 15.5058H12.9184M12.9184 15.5058C12.9184 15.9877 12.7266 16.4503 12.3858 16.7911C12.045 17.1319 11.5828 17.3233 11.1009 17.3233C10.6191 17.3233 10.157 17.1311 9.81634 16.7904C9.47565 16.4497 9.28425 15.9876 9.28425 15.5058M12.9184 15.5058C12.9184 15.0239 12.7266 14.5621 12.3858 14.2214C12.045 13.8806 11.5828 13.6892 11.1009 13.6892C10.6191 13.6892 10.157 13.8806 9.81634 14.2212C9.47565 14.5619 9.28425 15.024 9.28425 15.5058M9.28425 15.5058H2.29175M17.7084 4.49416H15.1209M11.4867 4.49416H2.29175M11.4867 4.49416C11.4867 4.01235 11.6781 3.55027 12.0188 3.20958C12.3595 2.86889 12.8216 2.67749 13.3034 2.67749C13.542 2.67749 13.7782 2.72448 13.9986 2.81578C14.219 2.90707 14.4193 3.04089 14.588 3.20958C14.7567 3.37827 14.8905 3.57854 14.9818 3.79895C15.0731 4.01936 15.1201 4.25559 15.1201 4.49416C15.1201 4.73273 15.0731 4.96896 14.9818 5.18937C14.8905 5.40977 14.7567 5.61004 14.588 5.77873C14.4193 5.94743 14.219 6.08124 13.9986 6.17254C13.7782 6.26383 13.542 6.31082 13.3034 6.31082C12.8216 6.31082 12.3595 6.11943 12.0188 5.77873C11.6781 5.43804 11.4867 4.97597 11.4867 4.49416Z" stroke="#1C1B1B" stroke-miterlimit="10" stroke-linecap="round"/>
          </svg>
          <span>Filter</span>
        </button>
         <div class="filter-chip-holder">
          <div class="chip-clear-button">
            <p>Clear All</p>
          </div>
        </div>
        </div>
        <p class="product-count"></p>
        </div>
       
      </div>`;
    var customChip = ({ chipValue, chipId }) => {
        return `
      <div class="filter-chip" id="${chipId}">
        <span class="chip-text">${chipValue}</span>
        <span class="remove-chip">&times;</span>
      </div>
    `;
    };
    var allFilterStateMobile = false;
    var handledCheckboxes = /* @__PURE__ */ new Set();
    poll(
        () => q("body") && q(".awt-filters-container"),
        () => {
            console.log(
                `%c🔥🔥🔥🔥 Custom Filter Running [[Control]] 🔥🔥🔥🔥`,
                "background: red; color: white; font-weight: bold; padding: 4px 8px; border-radius: 4px;"
            );
            const targetNav = q(".bundle-section-container");
            !q("#filter-button") && targetNav.insertAdjacentHTML("afterbegin", filterButton);
            const categoryList = qq(".awt-filters-container > button");
            if (window.innerWidth > 767) {
                q("body").insertAdjacentHTML("afterbegin", filterSidebar(categoryList));
            } else {
                qq(".awt-filters-container > button").forEach((el) => {
                    const categoryText = el.textContent.trim();
                    el.setAttribute("data-category", categoryText);
                });
                q("body").insertAdjacentHTML("afterbegin", filterSidebarMobile(categoryList));
                q(".filter-sidebar.mobile") && console.log("Mobile filter sidebar created");
            }
            q("#filter-button").addEventListener("click", () => {
                const sidebar = q(".filter-sidebar");
                sidebar.classList.toggle("hidden");
            });
            q(".close-button").addEventListener("click", () => {
                const sidebar = q(".filter-sidebar");
                sidebar.classList.toggle("hidden");
                q("#filter-button").classList.toggle("active");
            });
            q("body").addEventListener("click", (e) => {
                if (!q(".filter-sidebar.hidden") && !e.target.closest("#filter-button") && !e.target.closest(".filter-sidebar") && !e.target.closest(".awt-filters-container")) {
                    q(".filter-sidebar").classList.add("hidden");
                }
            });
            countObserver();
        },
        true
    );
    poll(
        () => q(".filter-sidebar") && window.innerWidth <= 767,
        () => {
            const mobileSidebar = q(".filter-sidebar");
            if (!mobileSidebar)
                return;
            handleMobileFilter();
        },
        true
    );
    poll(
        () => q(".filter-sidebar.mobile span.close-button") && allFilterStateMobile,
        () => {
            HandleMobileClose();
        },
        true
    );
    poll(
        () => q(".filter-sidebar") && window.innerWidth > 767,
        () => {
            const sidebar = q(".filter-sidebar");
            sidebar.addEventListener("click", (e) => {
                if (e.target.closest(".filter-sidebar .category-group > div button label input")) {
                    const checkbox = e.target.closest("input");
                    const selectedSubcategory = e.target.closest(".filter-sidebar .category-group > div button").textContent.trim();
                    const subCategoryList = [...qq(".awt-filters-container > button + div > div > button label")];
                    const selectedCategory = subCategoryList.find((category) => category.textContent.trim() === selectedSubcategory);
                    const chipHolder = q(".filter-chip-holder");
                    if (selectedCategory) {
                        const chipId = `chip-${selectedSubcategory.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`;
                        if (checkbox.checked) {
                            if (!selectedCategory.querySelector('input[type="checkbox"]').checked) {
                                selectedCategory.click();
                            }
                            selectedCategory.setAttribute("isFilterSelected", "true");
                            if (!q(`#${chipId}`)) {
                                insert(
                                    chipHolder,
                                    "afterbegin",
                                    customChip({ chipValue: selectedSubcategory, chipId })
                                );
                            }
                        } else {
                            if (selectedCategory.querySelector('input[type="checkbox"]').checked) {
                                selectedCategory.click();
                            }
                            selectedCategory.setAttribute("isFilterSelected", "false");
                            q(`#${chipId}`)?.remove();
                        }
                    }
                    const count = qq('[isFilterSelected="true"]').length;
                    q(".filter-sidebar .filter-count").textContent = count > 0 ? "(" + count + ")" : "";
                }
                if (e.target.closest(".filter-sidebar .apply-button")) {
                    sidebar.classList.add("hidden");
                    q("#filter-button")?.classList.remove("active");
                }
                if (e.target.closest(".filter-sidebar .clear-button")) {
                    q(".filter-sidebar").classList.add("clearCheck");
                    const resetBtn = Array.from(qq(".awt-filters-container button")).find(
                        (btn) => btn.textContent.trim() === "Reset"
                    );
                    if (resetBtn) {
                        qq('.filter-content input[type="checkbox"]').forEach((checkbox) => {
                            if (checkbox.checked) {
                                checkbox.click();
                            }
                        });
                        resetBtn.click();
                    }
                    qq(".filter-chip-holder .filter-chip").forEach((chip) => chip.remove());
                    q(".filter-sidebar").classList.remove("clearCheck");
                }
                if (e.target.closest(".category-group > button > span.chakra-button__icon")) {
                    e.target.closest(".category-group > button > span.chakra-button__icon svg")?.classList.toggle("rotate-90");
                }
                if (e.target.closest(".category-group > button") && !e.target.closest(".category-group > button span.chakra-button__icon")) {
                    e.target.closest(".category-group > button").querySelector("span.chakra-button__icon").click();
                    e.target.closest(".category-group > button").querySelector("span.chakra-button__icon svg")?.classList.toggle("rotate-90");
                }
            });
            q(".filter-chip-holder").addEventListener("click", (e) => {
                if (e.target.closest(".remove-chip")) {
                    const chip = e.target.closest(".filter-chip");
                    const chipText = chip.querySelector(".chip-text")?.textContent.trim();
                    const subCategoryList = [...qq(".awt-filters-container > button + div > div > button label")];
                    const selectedCategory = subCategoryList.find((category) => category.textContent.trim() === chipText);
                    if (selectedCategory) {
                        if (selectedCategory.querySelector('input[type="checkbox"]').checked) {
                            selectedCategory.click();
                            selectedCategory.setAttribute("isFilterSelected", "false");
                        }
                    }
                    chip.remove();
                    const count = qq('[isFilterSelected="true"]').length;
                    q(".filter-sidebar .filter-count").textContent = count > 0 ? "(" + count + ")" : "";
                }
            });
            qq(".category-group > button .chakra-button__icon").forEach((el) => {
                el.addEventListener("click", (e) => {
                    const subCategory = e.target.closest(".category-group").querySelector("div");
                    if (subCategory) {
                        subCategory.classList.toggle("hidden");
                        e.target.classList.toggle("rotate-180");
                    }
                });
            });
            q(".filter-chip-holder").addEventListener("click", (e) => {
                if (e.target.closest(".remove-chip")) {
                    const chip = e.target.closest(".filter-chip");
                    const chipText = chip.querySelector(".chip-text")?.textContent.trim();
                    const subCategoryList = [...qq(".awt-filters-container > button + div > div > button label")];
                    const selectedCategory = subCategoryList.find((category) => category.textContent.trim() === chipText);
                    if (selectedCategory) {
                        if (selectedCategory.querySelector('input[type="checkbox"]').checked) {
                            selectedCategory.click();
                            selectedCategory.setAttribute("isFilterSelected", "false");
                        }
                    }
                    const sidebarSubcategoryList = [...qq(".filter-sidebar .category-group > div button")];
                    const sidebarCategory = sidebarSubcategoryList.find(
                        (category) => category.textContent.trim() === chipText
                    );
                    if (sidebarCategory && sidebarCategory.querySelector('input[type="checkbox"]').checked) {
                        sidebarCategory.querySelector('input[type="checkbox"]').checked = false;
                    }
                    chip.remove();
                    const count = qq('[isFilterSelected="true"]').length;
                    q(".filter-sidebar .filter-count").textContent = count > 0 ? "(" + count + ")" : "";
                }
                if (e.target.closest(".chip-clear-button")) {
                    q(".filter-sidebar").classList.add("clearCheck");
                    qq('.filter-sidebar .category-group > div button input[type="checkbox"]').forEach((checkbox) => {
                        checkbox.checked && checkbox.click();
                    });
                    q(".filter-sidebar").classList.remove("clearCheck");
                }
            });
        },
        true
    );
    function countObserver() {
        const targetNode = q(".bundle-section-container");
        const config = { attributes: true, childList: true };
        const callback = (mutationsList, observer2) => {
            observer2.disconnect();
            const newCount = qq(".bundle-product-card").length;
            q(".product-count").textContent = newCount > 1 ? newCount + " items" : newCount + " item";
            q(".sidebar-product-count").textContent = newCount > 1 ? newCount + " items" : newCount + " item";
            q(".filter-sidebar .apply-button").disabled = newCount === 0;
            if (newCount < 1) {
                console.log(`%cNo items found for the current filter selection.`, "color: red; font-weight: bold;");
                insert(
                    q(".filter-sidebar .apply-button"),
                    "afterend",
                    '<div class="no-items-text">No farm-fresh finds with that combo-try switching up your filters</div>',
                    q(".filter-sidebar .no-items-text")
                );
                insert(
                    q(".filter-button-container"),
                    "afterend",
                    '<div class="no-items-text">No farm-fresh finds with that combo-try switching up your filters</div>',
                    q(".bundle-section-container .no-items-text")
                );
            } else {
                qq(".no-items-text").forEach((el) => el.remove());
            }
            setTimeout(() => {
                observer2.observe(targetNode, config);
            }, 200);
        };
        const observer = new MutationObserver(callback);
        targetNode && observer.observe(targetNode, config);
    }
    function handleMobileFilter() {
        const filterBtn = q("#filter-button");
        filterBtn.addEventListener("click", () => {
            if (!allFilterStateMobile) {
                document.querySelectorAll(".awt-filters-container .chakra-button.awt-filter-button").forEach((e) => {
                    e.click();
                });
                const sidebar = q(".filter-sidebar.mobile");
                poll(() => q(".chakra-stack"), () => {
                    qq(".chakra-stack").forEach((el, i) => {
                        if (!sidebar.querySelectorAll("button")[i]?.parentElement.querySelector(".chakra-stack") && sidebar.querySelectorAll("button")[i]?.textContent !== "Done" && sidebar.querySelectorAll("button")[i]?.textContent !== "Clear All") {
                            sidebar.querySelectorAll("button")[i]?.parentElement.insertAdjacentHTML("beforeend", `<div class="hidden">
                ${el.outerHTML}
              </div>`);
                        }
                    });
                    sidebarMobileFilterClick();
                });
                allFilterStateMobile = true;
            }
        });
    }
    function sidebarMobileFilterClick() {
        setupMobileAccordion();
        qq(".category-group.mobile .chakra-checkbox").forEach((checkbox) => {
            const checkboxId = checkbox.querySelector('input[type="checkbox"]')?.value;
            if (handledCheckboxes.has(checkboxId))
                return;
            handledCheckboxes.add(checkboxId);
            checkbox.addEventListener("click", (e) => {
                const targetFilterValue = checkbox.querySelector('input[type="checkbox"]').value;
                const portalCheckbox = q(`.chakra-portal .chakra-stack [value="${targetFilterValue}"]`);
                if (portalCheckbox) {
                    const currentState = portalCheckbox.checked;
                    if (currentState !== checkbox.querySelector("input").checked) {
                        portalCheckbox.click();
                    }
                }
            });
        });
    }
    function setupMobileAccordion() {
        const categoryButtons = qq(".filter-sidebar.mobile .category-group.mobile > button");
        categoryButtons.forEach((btn) => {
            if (!btn.hasAttribute("data-accordion-setup")) {
                btn.setAttribute("data-accordion-setup", "true");
                const contentDiv = btn.parentElement.querySelector("div:not(.filter-content)");
                if (contentDiv) {
                    contentDiv.classList.add("hidden");
                    btn.addEventListener("click", (e) => {
                        e.stopPropagation();
                        qq(".filter-sidebar.mobile .category-group.mobile > div:not(.hidden)").forEach((openDiv) => {
                            if (openDiv !== contentDiv) {
                                openDiv.classList.add("hidden");
                                const otherBtn = openDiv.previousElementSibling;
                                if (otherBtn && otherBtn.querySelector(".chakra-button__icon")) {
                                    otherBtn.querySelector(".chakra-button__icon svg").style.transform = "rotate(0deg)";
                                }
                            }
                        });
                        contentDiv.classList.toggle("hidden");
                        const icon = btn.querySelector(".chakra-button__icon svg");
                        if (icon) {
                            if (contentDiv.classList.contains("hidden")) {
                                icon.style.transform = "rotate(0deg)";
                                btn.classList.remove("active");
                            } else {
                                icon.style.transform = "rotate(180deg)";
                                btn.classList.add("active");
                            }
                        }
                    });
                }
            }
        });
    }
    function HandleMobileClose() {
        const sidebar = q(".filter-sidebar.mobile");
        const closeBtn = sidebar.querySelector(".close-button");
        const applyBtn = sidebar.querySelector(".apply-button");
        const clearBtn = sidebar.querySelector(".clear-button");
        const simulateClickEvents = () => {
            const loopCount = 6;
            const delay = 50;
            const createMouseEvent = (type) => new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window
            });
            for (let i = 0; i < loopCount; i++) {
                setTimeout(() => {
                    document.querySelectorAll(".chakra-modal__content-container.css-1ss038c").forEach((el) => {
                        ["pointerdown", "mousedown", "mouseup", "click"].forEach((type) => {
                            el.dispatchEvent(createMouseEvent(type));
                        });
                    });
                }, delay * i);
            }
        };
        closeBtn.addEventListener("click", () => {
            let count = 0;
            qq('.filter-content input[type="checkbox"]').forEach((checkbox) => {
                if (checkbox.checked) {
                    count++;
                }
            });
            q("#filter-button span").textContent = count > 0 ? "Filter (" + count + ")" : "Filter";
            qq(".category-group.mobile .active").forEach((activeBtn) => {
                activeBtn.classList.remove("active");
            });
            allFilterStateMobile = false;
            simulateClickEvents();
        });
        applyBtn.addEventListener("click", () => {
            qq(".filter-sidebar.mobile .category-group.mobile > div:not(.hidden)").forEach((openDiv) => {
                const categoryButtons = qq(".filter-sidebar.mobile .category-group.mobile > button");
                categoryButtons.forEach((btn) => {
                    const contentDiv = btn.parentElement.querySelector("div:not(.filter-content)");
                    if (openDiv !== contentDiv) {
                        openDiv.classList.add("hidden");
                        const otherBtn = openDiv.previousElementSibling;
                        if (otherBtn && otherBtn.querySelector(".chakra-button__icon")) {
                            otherBtn.querySelector(".chakra-button__icon svg").style.transform = "rotate(0deg)";
                        }
                    }
                });
            });
            closeBtn.click();
        });
        clearBtn.addEventListener("click", () => {
            q(".filter-sidebar.mobile").classList.add("clearCheck");
            qq('.filter-sidebar.mobile .category-group.mobile input[type="checkbox"]').forEach((checkbox) => {
                if (checkbox.checked) {
                    checkbox.click();
                }
            });
            q(".awt-filters-container").querySelector('button[data-category="Reset"]').click();
            q(".filter-sidebar.mobile").classList.remove("clearCheck");
        });
    }
})();